import React, { useState, useEffect } from 'react';
import { 
  Container, Row, Col, Card, CardBody, Badge, Button, Spinner, Alert, CardHeader 
} from 'reactstrap';
import { useNavigate, useParams } from 'react-router-dom';
import TimelineService from '../../services/KangarooServices/TimelineService';
import BreadCrumb from '../../Components/Common/BreadCrumb';

const Timelinedetail = () => {
  const [details, setDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const navigate = useNavigate();
  const { id } = useParams();

  const fetchDetails = async () => {
    try {
      setLoading(true);
      const result = await TimelineService.getDetails(id);
      setDetails(result);
    } catch (error) {
      setError("Failed to load timeline details");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (id) fetchDetails();
  }, [id]);

  const breadcrumbItems = [{ title: "Back To List", link: "/timeline" }];

  if (loading) {
    return (
      <div className="page-content">
        <Container fluid className="text-center mt-5">
          <Spinner color="primary" />
        </Container>
      </div>
    );
  }

  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb title="Timeline Details" pageTitle="Timeline" breadcrumbItems={breadcrumbItems} />


        {details && (
          <Row className="">
            <Col lg={12}>
              

              {/* Main Content Card */}
              <Card className="border-0 shadow-sm">
                <CardHeader className="bg-white border-bottom py-3">
                    <div className="d-flex align-items-center">
                        <Badge color="primary" className="p-2 me-3" style={{fontSize: '0.9rem'}}>
                            {details.year}
                        </Badge>
                        <h4 className="card-title mb-0 flex-grow-1">{details.title}</h4>
                    </div>
                </CardHeader>
                
                <CardBody className="p-4">
                  <div className="mb-4">
                    <h6 className="text-muted text-uppercase fw-semibold mb-3" style={{fontSize: '12px', letterSpacing: '1px'}}>
                        Description Content
                    </h6>
                    <div className="text-dark bg-light p-4 rounded border">
                      <div 
                        style={{ lineHeight: '1.7', color: '#495057' }}
                        dangerouslySetInnerHTML={{ __html: details.description }} 
                      />
                    </div>
                  </div>

                  <div className="pt-3 border-top d-flex text-muted" style={{fontSize: '13px'}}>
                    <span className="me-4">
                        <i className="ri-calendar-check-line me-1 text-primary"></i> 
                        Year: <strong>{details.year}</strong>
                    </span>
                    
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        )}
      </Container>
    </div>
  );
};

export default Timelinedetail;